import { Col, Row, Button, DatePicker, Input } from 'kenshin';
import { useState, useEffect } from 'react';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import AddressSelect from '@/components/AddressSelect';

const defaultPlace = () => ({
  applyOutArea: undefined,
  applyOutCompany: undefined,
  checkInDate: undefined,
  checkOutDate: undefined,
});

/** 长期驻场：外出公司 + 打卡地点 + 打卡时间（可多行） */
const GoOutPlaces = ({ value, onChange, disabled }) => {
  const [valueList, setValueList] = useState([defaultPlace()]);

  useEffect(() => {
    if (Array.isArray(value)) {
      setValueList(value.length > 0 ? value : [defaultPlace()]);
    }
  }, [value]);

  const handleChange = (list) => {
    setValueList(list);
    onChange?.(list);
  };

  const add = () => {
    handleChange([...valueList, defaultPlace()]);
  };

  const deleteItem = (i) => {
    handleChange(valueList.filter((_, index) => index !== i));
  };

  return (
    <div>
      {valueList.map((item, i) => (
        <div
          key={i}
          style={{
            border: '1px solid #e5e6eb',
            borderRadius: 8,
            padding: '14px 14px 8px',
            marginBottom: 10,
            background: '#fafafa',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 10,
            }}
          >
            <span style={{ fontSize: 13, fontWeight: 600, color: '#666' }}>
              {`打卡地点 ${i + 1}`}
            </span>
            {i > 0 && (
              <Button
                size="small"
                type="danger"
                disabled={disabled}
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  padding: 0,
                }}
                onClick={() => deleteItem(i)}
              >
                <MinusOutlined />
              </Button>
            )}
          </div>
          <Row gutter={12}>
            <Col span={8}>
              <div style={labelStyle}>外出公司</div>
              <Input
                value={item.applyOutCompany}
                placeholder="请输入外出公司"
                disabled={disabled}
                onChange={(e) => {
                  item.applyOutCompany = e.target.value;
                  handleChange([...valueList]);
                }}
              />
            </Col>
            <Col span={8}>
              <div style={labelStyle}>外出地</div>
              <AddressSelect
                value={item.applyOutArea}
                placeholder="请选择外出地"
                disabled={disabled}
                onChange={(val) => {
                  item.applyOutArea = val;
                  handleChange([...valueList]);
                }}
              />
            </Col>
            <Col span={8}>
              <div style={labelStyle}>打卡时间</div>
              <DatePicker.RangePicker
                style={{ width: '100%' }}
                value={
                  item.checkInDate && item.checkOutDate
                    ? [item.checkInDate, item.checkOutDate]
                    : undefined
                }
                disabled={disabled}
                showTime={{
                  defaultValue: [
                    moment().set({ h: 9, m: 0, s: 0 }),
                    moment().set({ h: 18, m: 0, s: 0 }),
                  ],
                }}
                onChange={(dates) => {
                  item.checkInDate = dates?.[0];
                  item.checkOutDate = dates?.[1];
                  handleChange([...valueList]);
                }}
              />
            </Col>
          </Row>
        </div>
      ))}
      <Button
        type="primary"
        icon={<PlusOutlined />}
        disabled={disabled}
        onClick={add}
      >
        新增打卡地点及时间
      </Button>
    </div>
  );
};

const labelStyle = {
  fontSize: 12,
  color: '#888',
  marginBottom: 6,
};

export default GoOutPlaces;
